import { api } from './api';

export async function validateAddress(
  addressLines: string[],
  countryCode: string,
  postalCode?: string,
) {
  const response = await api.post('/google/validate-address', {
    addressLines,
    countryCode,
    postalCode,
  })
  const data = await response.json()
  return data
}

export async function geocodeAddress(
  addressQuery: string,
) {
  const params = new URLSearchParams();
  params.set('addressQuery', addressQuery);
  const request = await api.get(`/google/geocode-address?${params.toString()}`)
  const data = await request.json()
  return data
}